import { useEffect, useState } from "react";

/**
 * Hook to load fonts and return a boolean indicating if the fonts are loaded
 * @param fontNames
 * @returns
 * @example
 * const isLoaded = useFonts("Roboto", "Open Sans");
 * if (isLoaded) {
 *  return <App />;
 * }
 */
export const useFonts = (...fontNames: string[]) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    Promise.all(fontNames.map((fontName) => document.fonts.load(`16px "${fontName}"`)))
      .then(() => {
        setIsLoaded(true);
      })
      .catch(() => console.warn("Something went wrong while loading fonts"));
  }, [fontNames]);

  return isLoaded;
};
